var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnstackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7539 19.8372L2.07239 12.9148C1.27751 12.5639 1.27751 11.4361 2.07239 11.0852L17.7539 4.16277C17.9905 4.05834 18.2583 4.04961 18.5012 4.13842L37.4317 11.0608C38.3071 11.3809 38.3071 12.6191 37.4317 12.9392L18.5012 19.8616C18.2583 19.9504 17.9905 19.9417 17.7539 19.8372Z",
    fill: "#6F7FE2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5707 28.3831L1.77574 19.8972C1.04197 19.5265 1.04417 18.4779 1.77949 18.1103L4.56663 16.7167C4.84032 16.5798 5.16162 16.5758 5.43864 16.7058L17.6101 22.4171C17.859 22.5339 18.145 22.543 18.4008 22.4424L34.3351 16.176C34.6179 16.0648 34.936 16.0882 35.1995 16.2398L38.3156 18.0315C39.0207 18.4369 38.9726 19.4697 38.2329 19.8079L19.4374 28.4001C19.161 28.5264 18.842 28.5202 18.5707 28.3831Z",
    fill: "#6F7FE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4795 36.313L1.80515 26.8811C1.08282 26.4464 1.18943 25.3679 1.98289 25.083L4.58925 24.1474C4.85116 24.0534 5.14039 24.0728 5.38743 24.2009L18.0698 30.7769C18.3415 30.9178 18.6627 30.9265 18.9417 30.8005L33.6313 24.1665C33.8678 24.0597 34.1365 24.049 34.3808 24.1367L36.8316 25.0164C37.6549 25.312 37.7287 26.4476 36.9505 26.8472L18.4518 36.3457C18.1439 36.5038 17.7761 36.4914 17.4795 36.313Z",
    fill: "#6F7FE2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnstackIcon);
export default __webpack_public_path__ + "static/media/unstack-icon.cde1723014136ca88136679eb406810f.svg";
export { ForwardRef as ReactComponent };